<div class="fixed left-0 top-14 bottom-0 bg-[var(--app-base)] flex flex-col items-center py-4 px-2.5 gap-1.5 z-[900] border-r border-[var(--app-border)] transition-[width] duration-300 overflow-hidden"
  [ngClass]="sideBarOpened ? 'w-[220px] !items-start' : 'w-16'">

  <ng-container *ngFor="let element of sideNavElements; let i = index">
    <ng-container *ngIf="checkRoles(element.roles) && checkFeatureFlag(element.featureFlag)">

      <!-- Section label (only visible when expanded) -->
      <div *ngIf="element.section && sideBarOpened"
        class="text-[10px] font-bold tracking-wider uppercase text-[var(--tertiary-text)] pt-3 px-4 pb-1 w-full">
        {{ element.section }}
      </div>

      <!-- Nav item -->
      <div [id]="'mat-icon' + i"
        [matTooltip]="sideBarOpened ? '' : ('NAV-BAR.'+element.label | translate)"
        matTooltipPosition="right"
        [routerLink]="element?.isButton ? null : element.route"
        (click)="sideBarOpened = false; emitSideBarChanges(element?.redirect)"
        class="h-[42px] rounded-[10px] flex items-center cursor-pointer text-[var(--base-text-alt-dark)] transition-all duration-200 gap-3 shrink-0 hover:bg-[var(--app-hover)] hover:text-[var(--primary-dark)] relative"
        [ngClass]="{
          'bg-[var(--primary-dark)] !text-white [&_span]:!text-white [&_img]:brightness-200 hover:!bg-[var(--primary-dark)]': element?.relatedRoutes?.includes(router.url.split('/')[1]),
          'w-[42px] justify-center': !sideBarOpened,
          'w-[calc(100%-12px)] px-3 justify-start': sideBarOpened
        }">
        <span *ngIf="!element.isImg" class="material-icons text-[26px]">{{ element.icon }}</span>
        <img *ngIf="element?.isImg"
          [src]="'assets/icons/' + element.icon + '.' + (element.imgExt || 'svg')"
          class="w-[26px] h-[26px]"
          [ngClass]="{'invert brightness-200': !element.imgExt && element?.relatedRoutes?.includes(router.url.split('/')[1]), 'invert': !element.imgExt && !element?.relatedRoutes?.includes(router.url.split('/')[1])}"
          alt="">
        <span *ngIf="sideBarOpened" class="text-[13px] font-medium whitespace-nowrap">
          {{ 'NAV-BAR.'+element.label | translate }}
        </span>
        <span *ngIf="sideBarOpened && element.isNew"
          class="text-[9px] font-bold uppercase bg-[#00B47D] text-white px-1.5 py-0.5 rounded-full leading-none ml-1">
          new
        </span>
        <span *ngIf="!sideBarOpened && element.isNew"
          class="absolute top-0.5 right-0.5 w-2 h-2 bg-[#00B47D] rounded-full">
        </span>
      </div>

    </ng-container>
  </ng-container>

  <div class="flex-1"></div>

  <!--
    Pinned to the bottom by the spacer above. SideNavComponent is rendered once by NavBarComponent
    at the app root and is not recreated on navigation, so this is present on every authenticated
    page, including one that failed to load.
  -->
  <app-report-bug-button [sideBarOpened]="sideBarOpened"></app-report-bug-button>
</div>
